import Holder from '../../../../base_components/Holder';
import './index.css';

export default Holder
